module.exports = __webpack_public_path__ + "static/media/graph_green.2405bf13.png";